export default "__VITE_ASSET__8a03e9e9__"